import { executeRequest, Request } from '@jfs/network'
import { createIntentRequestBody } from './ApiBody/createIntentBody'
import { APIEndPoints } from './APIEndpoints'
import { intentConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const createIntent = async (
  tokens: any,
  userAccessToken: string,
  amount: string,
  mid: string,
  merchantName: string,
) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.createIntent,
    method: 'POST',
    config: intentConfig(tokens),
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
    body: createIntentRequestBody(amount, mid, merchantName),
  }
  const data = await executeRequest(request)
  return responseParser(data.data)
}

export { createIntent }
